<template>
  <div class="mgx_introduce_bg" v-if="false">
    <div class="mgx_introduce_box">
      <div class="mgx_title">{{ $t('magnet_quick_trigger_introduction') }}</div>
      <img class="mgx_content" :src="getStepImg()" />
      <!-- <div class="confirm_button text_white_gradient_bg" @click="show_mgx_introduce = false">{{ $t('i_see') }}</div> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import i18n from '@/languages/i18n'
// import { show_mgx_introduce } from './mgx_set.vue';
import { onMounted, ref, Ref } from 'vue'
import { Brand, getBrand } from '@/brand/brand'

const brand: Ref<string> = ref('')
onMounted(() => {
  getBrand().then((value: Brand) => {
    if (value === Brand.carotmas) {
      brand.value = 'carotmas'
    } else {
      brand.value = 'img'
    }
  })
})

const getStepImg = () => {
  if (i18n.global.locale.includes('zh')) {
    return new URL(`../../assets/${brand.value}/mgx_set_zh.png`, import.meta.url).href
  } else {
    return new URL(`../../assets/${brand.value}/mgx_set_en.png`, import.meta.url).href
  }
}
</script>

<style>
.highlight {
  color: #f5a100;
  font-weight: bold;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.mgx_introduce_bg {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  top: 0;
  -webkit-app-region: no-drag;

  .mgx_introduce_box {
    width: 836px;
    height: 520px;
    background: #fff;
    padding: 40px;

    .mgx_title {
      text-align: center;
      font-weight: bold;
      font-size: 24px;
      color: #222;
    }

    .mgx_content {
      display: flex;
      width: 756px;
      margin-top: 30px;
    }

    .confirm_button {
      // background: @main_color;
      width: 112px;
      height: 42px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      margin: 30px auto 0 auto;
      cursor: pointer;
    }
  }
}
</style>
